// Program index: every degree/certificate heading in a catalog with its page,
// so "what degrees does this college offer?" (spread over dozens of pages) and
// "requirements for the computer science degree" can find the right pages.
// answer.mjs adds the list to degree/program questions and uses it to pull in
// named programs' pages.
//
// Two heading styles cover the catalogs tested so far:
//   "Mathematics - A.S.-T"                                          (Feather River)
//   "Biology for Transfer - Major #2345" + next line "Associate in Science"  (Fresno)
// Wrapped titles come out imperfect; the model tidies them when it answers.
// Catalogs using other conventions get an empty index and fall back to search.
export function extractPrograms(pages) {
  const DASH = /^(.{3,80}?) - (A\.A\.(-T)?|A\.S\.(-T)?|AA-T|AS-T|Certificate of [A-Za-z]+)\s*$/;
  const MAJOR = /^(.*?)\s*-?\s*Major #\s?\d+/;
  const seen = new Set();
  const programs = [];
  const add = (title, page) => {
    title = title.replace(/\s+-\s*$/, "").replace(/\s+/g, " ").trim();
    if (!seen.has(title)) seen.add(title) && programs.push({ title, page });
  };
  for (const p of pages) {
    const lines = p.text.split("\n").map((l) => l.trim());
    lines.forEach((line, i) => {
      if (DASH.test(line)) return add(line, p.page);
      const m = line.match(MAJOR);
      if (!m) return;
      let title = m[1];
      const prev = lines[i - 1] || "";
      // Title wrapped onto two lines ("Technology - Formerly ..." etc.)
      if (title.length < 3 || (prev && prev.length < 45 && !/[.:;0-9]$/.test(prev) && !/^(Total|Certificate|Associate)/.test(prev))) {
        title = `${prev} ${title}`;
      }
      add(`${title} - ${lines[i + 1] || ""}`, p.page);
    });
  }
  return programs;
}
